<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M4 4v2h4V4H4zm0 3h4v3H4V7zm0 4h4v3H4v-3zm0 4h4v5H4v-5zm5 0v5h6v-5H9zm7 0v5h4v-5h-4zm0-1v-3h4v3h-4zm0-4h4V7h-4v3zm0-4h4V4h-4v2zm-1-2v10H9V4h6zM3 2a1 1 0 00-1 1v18a1 1 0 001 1h18a1 1 0 001-1V3a1 1 0 00-1-1H3zm8 6h2v2h-2V8zm-1 0a1 1 0 011-1h2a1 1 0 011 1v3a1 1 0 01-1 1h-2a1 1 0 01-1-1V8z"/></svg>